import { GRAY_800, GRAY_900 } from 'constants/styling/theme'

import { MUIDivider } from 'components/common/MUIDivider'
import React from 'react'
import RedoIcon from '@mui/icons-material/Redo'
import Stack from '@mui/material/Stack'
import UndoIcon from '@mui/icons-material/Undo'
import { WHITE } from 'constants/styling/upbrandingTheme'
import { useMaskDrawer } from 'components/pages/AIStudioPhotoEditing/_main/ClientAIStudio/MaskDrawer/MaskDrawer.context'
import { useTranslation } from 'react-i18next'

/**
 * @component
 * Undo/Redo panel component that allows users to undo and redo actions in the photo editing tool.
 *
 * @example
 * <UndoRedoPanel />
 */
export const UndoRedoPanel: React.FC = () => {
  const { t } = useTranslation(['common'])
  const { onUndo, onRedo, undoStack, redoStack } = useMaskDrawer()

  const isUndo = undoStack.current.length !== 0
  const isRedo = redoStack.current.length !== 0

  return (
    <Stack flexDirection="row" justifyContent="center" alignItems="center" margin="2.4rem 0">
      <Stack flexDirection="row" height="3.2rem" alignItems="center" borderRadius="3rem" padding=".6rem 1.6rem" border={`1px solid ${GRAY_900}`}>

        <Stack onClick={isUndo ? onUndo : undefined} sx={{ cursor: isUndo ? 'pointer' : 'not-allowed' }}>
          <UndoIcon sx={{ color: isUndo ? WHITE : GRAY_800 }} titleAccess={t('undo')} />
        </Stack>

        <MUIDivider orientation="vertical" margin={12} color={GRAY_800} />

        <Stack onClick={isRedo ? onRedo : undefined} sx={{ cursor: isUndo ? 'pointer' : 'not-allowed' }}>
          <RedoIcon sx={{ color: isRedo ? WHITE : GRAY_800 }} titleAccess={t('redo')} />
        </Stack>

      </Stack>
    </Stack>
  )
}
